import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractSelectInput} from "../abstract-select-input";
import {FUIEventsService} from "../../../../events/events.service";import {FUIOptionsService} from "../../../framework/options.service";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIHeaderSelectInputComponent),
            multi: true
        }
    ],
    selector: "fui-header-select-input",
    styleUrls: ["./header-select-input.component.scss"],
    templateUrl: "./header-select-input.component.html"
})
export class FUIHeaderSelectInputComponent extends FUIAbstractSelectInput {
    constructor(elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef,
                eventsService: FUIEventsService,
                optionsService: FUIOptionsService) {
        super(elementRef, changeDetectorRef, eventsService, optionsService);
    }
}
